import MediaKit from "@/components/site/MediaKit";

const topics = [
  "Leadership Under Pressure",
  "Decision Margin: The Hidden Math of Resilience",
  "Why Organizations Fail Before the Crisis",
  "Continuity, Coordination & Command",
  "Building Cultures That Hold Under Stress",
];

const formats = [
  { k: "Keynotes", v: "30–60 min addresses for conferences, summits, and executive events." },
  { k: "Workshops", v: "Half-day and full-day sessions for leadership teams and cohorts." },
  { k: "Briefings", v: "Executive-team briefings on crisis posture and decision capacity." },
  { k: "Panels", v: "Moderated discussions and expert panels on resilience and risk." },
];

export default function Speaking() {
  return (
    <section
      id="speaking"
      data-testid="speaking-section"
      className="relative py-24 lg:py-32 border-t border-[#262626]"
    >
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://images.unsplash.com/photo-1544531586-fde5298cdd40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxleGVjdXRpdmUlMjBzcGVha2luZyUyMHByZXNlbnRhdGlvbiUyMHN0YWdlfGVufDB8fHx8MTc4MTI4NjIyNXww&ixlib=rb-4.1.0&q=85"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/95 via-black/70 to-black" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="overline overline-red mb-6">04 — Speaking & Training</div>
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-[-0.03em] leading-[0.95]">
              From the operations center
              <br />
              to <span className="text-[#d92d20]">the keynote stage.</span>
            </h2>
            <p className="mt-8 text-white/75 leading-relaxed max-w-2xl">
              Practical, research-backed sessions that translate decades of
              operational experience into clear, actionable insight for leaders in
              government, healthcare, higher education, and public safety.
            </p>

            <div className="mt-12">
              <div className="overline mb-4">Signature Topics</div>
              <ul className="grid sm:grid-cols-2 gap-px bg-[#262626] border border-[#262626]">
                {topics.map((t, i) => (
                  <li
                    key={t}
                    data-testid={`speaking-topic-${i}`}
                    className="bg-[#0a0a0a] p-5 flex items-start gap-4 group hover:bg-[#101010] transition-colors"
                  >
                    <span className="font-mono text-xs text-[#d92d20] mt-1">0{i + 1}</span>
                    <span className="text-white/90 text-[15px] font-medium leading-snug">{t}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-5 lg:pl-8 lg:border-l lg:border-[#262626]">
            <div className="overline mb-6">Engagement Formats</div>
            <div className="space-y-px bg-[#262626] border border-[#262626]">
              {formats.map((f, i) => (
                <div key={f.k} data-testid={`speaking-format-${i}`} className="bg-[#0a0a0a] p-6">
                  <div className="font-display font-bold text-xl text-white mb-1 tracking-tight">{f.k}</div>
                  <div className="text-sm text-white/65 leading-relaxed">{f.v}</div>
                </div>
              ))}
            </div>

            <a
              href="#contact"
              data-testid="speaking-cta"
              className="mt-8 inline-flex items-center justify-center gap-3 bg-[#d92d20] hover:bg-[#b91d13] text-white px-7 py-4 text-[12px] font-semibold tracking-[0.18em] uppercase transition-colors w-full sm:w-auto"
            >
              Book Dr. Avory →
            </a>
          </div>
        </div>

        <MediaKit />
      </div>
    </section>
  );
}
